"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.VERTICAL_SPACING = exports.MARKER_EXAMPLE_SIZE = exports.HORIZONTAL_SPACING = void 0;

var _interfaces = require("./interfaces");

var MARKER_EXAMPLE_SIZE = 16;
exports.MARKER_EXAMPLE_SIZE = MARKER_EXAMPLE_SIZE;
var VERTICAL_SPACING = 'S200';
exports.VERTICAL_SPACING = VERTICAL_SPACING;
var HORIZONTAL_SPACING = 'S300';
exports.HORIZONTAL_SPACING = HORIZONTAL_SPACING;
var defaultProps = {
  markers: [],
  layout: _interfaces.DateMarkerLegendLayout.Vertical
};
exports.defaultProps = defaultProps;